// Deprecated: Use achlRelationships.dtos.ts instead
export enum TradingBlockAchBankLinkStatusEnum {
  PendingCreateApproval = 'PendingCreateApproval',
  Pending = 'Pending',
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  CreateRejected = 'CreateRejected',
  Rejected = 'Rejected',
}
